import { getEditorState } from "./util/State";
import PersistingObservable from "./util/PersistingObservable";
export const state = getEditorState();
export const translitLang = new PersistingObservable(state.translitLang, "translitLang", "translit_language_selected", value => value.shortName);
export const translitEnabled = new PersistingObservable(state.translitEnabled, "translitEnabled", "translit_toggled");
export const counterType = new PersistingObservable(state.counterType, "counterType", "counter_type_selected");
translitLang.persist();
